
const PlatformTest = {
    android: () => {
        return navigator.userAgent.match(/Android/i);
    },
    blackberry: () => {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    ios: () => {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    opera: () => {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    windows: () => {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: () => {
        return (PlatformTest.android() || PlatformTest.blackberry() || PlatformTest.ios() || PlatformTest.opera() || PlatformTest.windows());
    }
};

export default PlatformTest;
